import { TranslateService } from '@ngx-translate/core';
import { BuildingType } from '@iss/libs/graphql';
import { ChangeDetectorRef, Pipe, PipeTransform } from '@angular/core';

import { BaseEnumTranslationPipe } from '@iss/wo-common/pipes';

@Pipe({ name: 'buildingType', pure: false, standalone: true })
export class BuildingTypePipe extends BaseEnumTranslationPipe<BuildingType> implements PipeTransform {
  protected readonly translationPrefix = 'iss-mc.enum.building-type';

  public constructor(
    translateService: TranslateService,
    changeDetectorRef: ChangeDetectorRef,
  ) {
    super(translateService, changeDetectorRef);
  }
}
